"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_VERSION = exports.EVENT_NAME = void 0;
exports.ftReport = ftReport;
const fego_render_1 = require("@futuweb/fego-render");
exports.EVENT_NAME = {
    CLICK_SHARE_BTN: 'ClickShareBtn',
    SHARE: 'Share'
};
exports.EVENT_VERSION = {
    CLICK_SHARE_BTN: 1,
    SHARE: 10
};
function ftReport(eventName, reportObj = {}, eventVersion = exports.EVENT_VERSION.CLICK_SHARE_BTN) {
    const ftReportIns = (0, fego_render_1.getFtReport)();
    ftReportIns.sdReport({
        eventName,
        eventVersion,
        payload: reportObj
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVwb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVlBLDRCQU9DO0FBbkJELHNEQUFtRDtBQUV0QyxRQUFBLFVBQVUsR0FBRztJQUN0QixlQUFlLEVBQUUsZUFBZTtJQUNoQyxLQUFLLEVBQUUsT0FBTztDQUNqQixDQUFDO0FBRVcsUUFBQSxhQUFhLEdBQUc7SUFDekIsZUFBZSxFQUFFLENBQUM7SUFDbEIsS0FBSyxFQUFFLEVBQUU7Q0FDWixDQUFDO0FBRUYsU0FBZ0IsUUFBUSxDQUFDLFNBQVMsRUFBRSxTQUFTLEdBQUcsRUFBRSxFQUFFLFlBQVksR0FBRyxxQkFBYSxDQUFDLGVBQWU7SUFDNUYsTUFBTSxXQUFXLEdBQUcsSUFBQSx5QkFBVyxHQUFFLENBQUM7SUFDbEMsV0FBVyxDQUFDLFFBQVEsQ0FBQztRQUNqQixTQUFTO1FBQ1QsWUFBWTtRQUNaLE9BQU8sRUFBRSxTQUFTO0tBQ3JCLENBQUMsQ0FBQztBQUNQLENBQUMifQ==